import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserPosition: Getter<UserState, RootState> = (state) => {
  return state.current?.position || ''
}

export default getUserPosition
